module.exports = __webpack_public_path__ + "static/media/video_mirro.b765d835.mp4";